import React from "react";
import PropTypes from "prop-types";
import ConservationScore from "../../../../../models/ConservationScore";

function ConservationTitle({ item, actions }) {
  return item ? (
    <>
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          {item.region.chromosome.name}:{item.region.x0}
        </div>
        <div className="tw-w-24" />
        {actions}
      </div>
      <div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-32">phyloP100way score:</div>
          <div>
            {item.phylopScore === null ? "Not Defined" : item.phylopScore}
          </div>
        </div>
      </div>
    </>
  ) : null;
}

ConservationTitle.propTypes = {
  item: PropTypes.instanceOf(ConservationScore).isRequired,
  actions: PropTypes.node,
};

ConservationTitle.defaultProps = {
  actions: null,
};

export default ConservationTitle;
